// extracted by mini-css-extract-plugin
module.exports = {"container":"Start_container__3uuEH","imgContainer":"Start_imgContainer__2j6Qn","show":"Start_show__17Crq","content":"Start_content__3t6vz"};